// Typelizer digest b63a0ada56161a17780a1dc51823ba85
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /rails/info/properties */
  properties: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/rails/info/properties', {}, options),
    method: 'get',
  }),

  /** GET /rails/info/routes */
  routes: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/rails/info/routes', {}, options),
    method: 'get',
  }),

  /** GET /rails/info/notes */
  notes: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/rails/info/notes', {}, options),
    method: 'get',
  }),

  /** GET /rails/info */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/rails/info', {}, options),
    method: 'get',
  }),
}
